import BaseModel from '@/engage/services/legacy/BaseModel'
import { useSessionStore } from '@/common/stores/sessionStore'
import { UnprotectedParameterEnum } from '@/common/types/instanceParameter'

export default class FeatureFlag extends BaseModel {
  constructor() {
    super()

    this._service = 'api/v1'
    this._model = 'feature-flags'
  }

  async customerMergeEnabled() {
    const session = useSessionStore()
    return session.getParameterMap.get(UnprotectedParameterEnum.USE_MCR_FEATURE)?.value === 'true'
  }
}
